import { Injectable } from "@angular/core";
import { IPageRequestOptions, IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { take } from "rxjs/operators";
import { StatisticsRepository } from "../statistics.repository";
import { IRoundBet } from "../../core/round/interfaces";
import { statisticsRecordsPageLength } from "../constants";
import { GetLastStatisticsPageReachedUseCase } from "./get-last-statistics-page-reached.use-case";
import { PaginationErrors } from "@karma-games/angular-devkit/src/lib/classes/errors";

@Injectable({ providedIn: "root" })
export class RequestNewMyBetsPageUseCase implements IUseCase<any, Promise<void>> {
    constructor(private statisticsRepository: StatisticsRepository,
                private getLastStatisticsPageReachedUseCase: GetLastStatisticsPageReachedUseCase) {
    }

    execute(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.getLastStatisticsPageReachedUseCase.execute()) {
                reject(new PaginationErrors.LastPageReached());
            }
            this.statisticsRepository.getMyBets().pipe(take(1)).subscribe(async (myBets: IRoundBet[]) => {
                const options: IPageRequestOptions = { skip: myBets.length, take: statisticsRecordsPageLength };
                try {
                    const results: IRoundBet[] = await this.statisticsRepository.requestNewMyBetsPage(options);
                    if (myBets.length < results.length) {
                        resolve();
                    } else {
                        throw new PaginationErrors.NoMoreRecords();
                    }
                } catch (e) {
                    reject(e);
                }
            });
        });
    }
}
